<template>
  <div
    class="flex items-center justify-center w-full p-3 md:p-6 bg-lightgray-lightest"
  >
    <a class="text-blue p-2" @click="adjustDate('backward')">
      <i class="far fa-angle-left fa-fw text-xl"></i>
    </a>
    <span class="mx-8 text-lg uppercase text-center">{{ date }}</span>
    <a class="text-blue p-2" @click="adjustDate('forward')">
      <i class="far fa-angle-right fa-fw text-xl"></i>
    </a>
  </div>
</template>
<script>
export default {
  name: "date-bar",
  props: {
    date: String
  },
  methods: {
    adjustDate(direction) {
      this.$emit("adjust-date", direction);
    }
  }
};
</script>
